import fetchCreator from "../utils/fetchCreator";

const client = new fetchCreator();

export const fetchRoutes = (params: any) =>
  client.get("route", params).then(({ data }: any) => data);
